import { render, staticRenderFns } from "./CenterView.vue?vue&type=template&id=5b8b302b&"
import script from "./CenterView.vue?vue&type=script&lang=js&"
export * from "./CenterView.vue?vue&type=script&lang=js&"
import style0 from "./CenterView.vue?vue&type=style&index=0&id=5b8b302b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports